<template>
<div>
<audioPlay v-if="audioShow" :currentIndex="currentIndex" :info="currentInfo" @audioClose="audioShow=false"></audioPlay>
  <van-list v-if="list.length" v-model="loading" :finished="finished" finished-text="没有更多了">
    <div class="list">
      <div class="idea-list" v-for="(item,index) of list" :key="item.id" @click="jumpIdea(item)">
        <div class="price-name">{{ item.name }}</div>
        <div class="auther" v-if="!item.video_url">
          <img class="autherImg" src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/%E7%BB%84%2029%402x.png" alt=""/>
          <div class="autherName">
            托育高研院官方账号
            <div class="time">{{item.updated_at}}</div>
          </div>
        </div>
        <div class="content" v-if="!item.video_url">
          {{item.content}}
        </div>
        <div class="itemBottom"  v-if="!item.video_url">{{item.pv_count}}个人看过</div>
        <div class="itemBottom" v-else>
          {{item.duration}}
          <div class="studyNum">
              {{item.pv_count}}人学习过
          </div>
          <div class="play" @click.stop="toPlay(index)">
                <img src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/%E7%BC%96%E7%BB%84%202%E5%A4%87%E4%BB%BD%202%402x.png"/>
          </div>
        </div>
      </div>
    </div>
  </van-list>
  <van-empty style="margin: 0 auto" v-if="!list.length" description="暂无数据" />
</div>
</template>

<script>
import audioPlay from "@/components/audioPlay"
export default {
  name: "Home",
  props:['list'],
  data() {
    return {
      loading: false,
      finished: true,
      audioShow:false,
      currentInfo:null,
      currentIndex:0,
    }
  },
  components:{audioPlay},
  mounted() {
  },
  destroyed() {
  },
  computed: {
  },
  methods: {
    
    jumpIdea(item) {
      this.$router.push({
        path:'./ideaDetail',
        query:{
          id:item.id,
        }
      })
    },
    toPlay(index){
      this.currentIndex = index
      this.currentInfo = this.list[index]
      this.audioShow = true
    }
  },
  beforeRouteUpdate(to, from, next) {
    console.log('beforeRouteUpdate')
    next()
  },
};
</script>

<style lang="scss" scoped>

 
  .idea-list {
    background: #fff;
    box-shadow: 0 5px 10px #33333308;
    border-radius: 12px;
    padding: 20px 20px;
    margin-bottom: 20px;
    cursor: pointer;

   

    .content {
      display: flex;
      width: 100%;

      .cover {
        flex: 0 0 280px;
        margin-right: 20px;
        width: 280px;
        height: 136px;
        border-radius: 10px;
        overflow: hidden;
      }

      .detail {
        display: flex;
        align-items: flex-start;
        justify-content: center;
        flex-direction: column;
        flex: auto;

        .text {
          font-size: 14px;
          color: #666;
          overflow: hidden;
          display: -webkit-box;
          /*弹性伸缩盒子*/
          -webkit-box-orient: vertical;
          /*子元素垂直排列*/
          -webkit-line-clamp: 5;
          /*可以显示的行数，超出部分用...表示*/
          text-overflow: ellipsis;
          /*（多行文本的情况下，用省略号“…”隐藏溢出范围的文本)*/
        }

        .more {
          font-size: 14px;
          color: #175199;
          display: flex;
          align-items: center;
          margin-top: 10px;
          cursor: pointer;
        }

      }

      .handle {
        margin-left: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 0 0 120px;
      }

      .btn {
        cursor: pointer;
        border-radius: 6px;
        line-height: 40px;
        font-weight: 500;
        border-radius: 6px;
        color: #a40001;
        background: #f7f7f7;
        padding: 0 30px;
        font-size: 14px;

        &:hover {
          color: #fff;
          background: #a40001;
        }
      }
    }
  }

  .type {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: 60px;
    margin: 20px 0;

    .type-btn {
      width: 140px;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #a40001;
      background: #eee;
      border-radius: 4px;
      cursor: pointer;
      margin-right: 20px;
      transition: all 0.3s;

      &:hover {
        color: #fff;
        background: #a40001;
      }
    }

    .active {
      color: #fff;
      background: #a40001;
    }
  }

 




.idea-list .price-name{
  font-size: 30px;
  padding: 20px 0;
}
.idea-list .auther{
  display: flex;
  align-items: center;
}
.idea-list .auther .autherImg{
    width: 60px;
    height: 60px;
    margin-right: 6px;
}
.idea-list .auther .autherName{
  font-size: 28px;
}
.idea-list .auther .time{
  font-size: 24px;
  color: #666666;
}
.idea-list .content{
  color: #555555;
  font-size: 26px;
  padding: 20px 0;
}
.idea-list .itemBottom{
  width: 100%;
  border-top: 1px solid #EEEEEE;
  // margin: 0 auto;
  display: flex;
  height: 72px;
  font-size: 26px;
  align-items: center;
  color: #666666;
}
.idea-list .itemBottom .studyNum{
  flex: 1;
  color: #A7090A;
  margin-left:10px;
  padding-left:10px;
  position: relative;
}
.idea-list .itemBottom .studyNum::before{
  content: '';
  display: block;
  position: absolute;
  width: 1px;
  height: 20px;
  left:0;
  top:50%;
  background-color: #666;
  transform:translate(0,-50%);
}
.idea-list .itemBottom .play img{
  width: 40px;
  height: 40px;
}

</style>

